import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { EventsTableInfo, EventsTableMarketsLoader } from 'src/domains/sportsbook/shared/Components';
import { PriceChangeLegend } from 'src/domains/layouts/webview/components/priceChangeLegend/PriceChangeLegend';
import { SpecialEventsList } from 'src/domains/layouts/layouts/specialSportPage/eventList/EventsList';
import { SpecialSportsState } from 'src/domains/sportsbook/state/specialSportsState/SpecialSportsState';
import { useCommon } from 'src/domains/common/Common';
import { SpecialSportsListState } from 'src/domains/sportsbook/state/specialSportsState/SpecialSportListState';

interface StatusType {
    isLoading: boolean;
    sportNotFound: boolean;
    hasCompetitions: boolean;
}

const Status = observer('Status', ({ isLoading, sportNotFound, hasCompetitions }: StatusType) => {
    if (isLoading) {
        return <EventsTableMarketsLoader />;
    }

    if (sportNotFound) {
        return (
            <EventsTableInfo>
                <I18n
                    langKey='specialSport.notFound'
                    defaultText='Sorry, this sport could not be found.'
                />
            </EventsTableInfo>
        );
    }

    if (!hasCompetitions) {
        return (
            <EventsTableInfo>
                <I18n
                    langKey='events.table.empty'
                    defaultText="Sorry, we haven't found any events with such criteria."
                />
            </EventsTableInfo>
        );
    }

    return null;
});

interface EventsTableType {
    specialSportState: SpecialSportsState;
}

export const EventsTable = observer('EventsTable', ({ specialSportState }: EventsTableType) => {
    const common = useCommon();
    const isLoading = SpecialSportsListState.get(common).activeSpecialSports === 'loading';
    const sportNotFound = !isLoading && specialSportState.currentSport === null;
    const hasCompetitions = specialSportState.competitions.some((competition) => competition !== undefined);

    return (
        <>
            <SpecialEventsList specialSportsState={specialSportState} />

            <Status
                isLoading={isLoading}
                sportNotFound={sportNotFound}
                hasCompetitions={hasCompetitions}
            />

            {!isLoading && !sportNotFound && hasCompetitions ? <PriceChangeLegend isRace={false} /> : null}
        </>
    );
});
